export default {
  'pages.security.title1': '登录手机号修改',
  'pages.security.title2': '登录密码修改',
  'pages.security.phone': '手机号',
  'pages.security.modify': '修改',
  'pages.security.form.code': '验证码',
  'pages.security.form.code.placeholder': '请输入验证码',
  'pages.security.form.sendCode': '获取验证码',
  'pages.security.form.hasSend': '已发送',
  'pages.security.form.newPassword': '新登录密码',
  'pages.security.form.newPassword.placeholder':
    '密码长度设置8-20位，必须包含数字和字母组合，区分大小写',
  'pages.security.form.newPassword1': '重复新密码',
  'pages.security.form.newPassword1.error': '两次密码不一致',
  'pages.security.form.newPassword1.placeholder': '请再次输入密码',
  'pages.security.form.modifyBtn': '确认修改',
  'pages.security.form.sendCode.fail': '验证码发送失败，请重新发送',
  'pages.security.form.submit.success': '密码修改成功, 请重新登录',
  'pages.security.form.submit.fail': '密码修改失败，请重试',

  'pages.security.modal.title': '修改登录手机号',
  'pages.security.modal.oldPhone': '原手机号',
  'pages.security.modal.next': '下一步',

  'pages.security.modal.newPhone': '修改手机号',
  'pages.security.modal.newPhone.placeholder': '请输入新手机号',
  'pages.security.modal.newPhone.valid': '请输入正确的手机号码',
  'pages.security.modal.submit.success': '登录手机号修改成功',
};
